import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { StringFilter } from "clarity-angular";
import { AlertService } from '../services/alert.service';


class ItemFilter implements StringFilter<string> {
    accepts(user: any, search: string): boolean {
        return user.email.toLowerCase().indexOf(search) >= 0;
    }
}

@Component({
    styleUrls: ['./authuser.component.scss'],
    templateUrl: './authuser.component.html'
})
export class AuthUsersComponent {
    private itemFilter = new ItemFilter();
    title: string = "Manage Users";
    dataHeaders = [
        {
            name: "Name",
            class: ""
        },
        {
            name: "Email",
            class: "",
            filter: "itemFilter"
        },
        {
            name: "Type",
            class: ""
        },
        {
            name: "Actions",
            class: ""
        }
    ];
    modalProps = {
        state: false,
        backdrop: true,
        title: this.translateService.instant('authUser.deleteUser'),
        bodyContent: this.translateService.instant('admin.EnableRelMsg'),
        cancelButton: this.translateService.instant('cancel'),
        okButton: this.translateService.instant('limit.delete'),
        cancelBClass: "btn-outline",
        okBClass: "btn-danger"
    };
    groups: any = [
        {
            name: "Program Management",
            users: [
                {
                    name: "Kranti",
                    email: "kadhikari@omnissa.com",
                    type: "Employee"
                },
                {
                    name: "Aaaaa",
                    email: "aaaa@omnissa.com",
                    type: "Employee"
                },
                {
                    name: "Bbbbb",
                    email: "bbbb@omnissa.com",
                    type: "Employee"
                },
                {
                    name: "Ccccc",
                    email: "cccc@omnissa.com",
                    type: "Employee"
                }
            ]
        },
        {
            name: "Partners Under NDA",
            users: [
                {
                    name: "Ddddd",
                    email: "dddd@dell.com",
                    type: "Partner Central"
                },
                {
                    name: "Eeeee",
                    email: "eeee@cisco.com",
                    type: "Partner Central"
                },
                {
                    name: "Fffff",
                    email: "ffff@lenovo.com",
                    type: "Partner Central"
                }
            ]
        },
        {
            name: "Release Management",
            users: [
            ]
        }
    ];
    addUser: any = {
        state: false,
        backdrop: true,
        title: "Add User",
        subTitle: "Fill in the details",
        cancelButton: "Cancel",
        okButton: "Add",
        cancelBClass: "btn-outline",
        okBClass: "btn-primary",
        elements: [
            {
                type: "text",
                label: "Name",
                size: 45,
                placeHolder: "Enter value here",
                selectedValue: ""
            },
            {
                type: "text",
                label: "Email",
                size: 45,
                placeHolder: "Enter value here",
                selectedValue: ""
            },
            {
                type: "select",
                label: "Type",
                options: [
                    "Select",
                    "Employee",
                    "Partner Central"
                ],
                selectedValue: ""
            },
            {
                type: "select",
                label: "Authorization Group",
                options: [
                    "Select",
                    "Program Management",
                    "Performance Management",
                    "QE",
                    "Release Management",
                    "Developement",
                    "Product Management",
                    "Product Owners",
                    "Omnissa Employees",
                    "Partners Under NDA"
                ],
                selectedValue: ""
            }
        ]
    };
    constructor(private alertService: AlertService, private translateService: TranslateService) {

    }
    modalHandler(btnOutput: boolean) {
        if (btnOutput) {
            this.alertService.success(this.modalProps.title + " - Succesful");
            window.setTimeout(() => this.alertService.clear(), 3000);
        } else {
            this.alertService.warn(this.modalProps.title + this.translateService.instant('revertAlertLabel'));
            window.setTimeout(() => this.alertService.clear(), 3000);
        }
    }
    formModalHandler(btnOutput: boolean) {
        if (btnOutput) {
            this.alertService.success(this.addUser.title + " - Succesful");
            window.setTimeout(() => this.alertService.clear(), 3000);
        } else {
            this.alertService.warn(this.addUser.title + this.translateService.instant('revertAlertLabel'));
            window.setTimeout(() => this.alertService.clear(), 3000);
        }
    }
    manageUsers(user: any, group: string, type: string) {
        switch (type) {
            case "add":
                this.addUser.title = "Add User";
                this.addUser.subTitle = "Fill in the details";
                for (let i = 0; i <= 3; i++) {
                    if (this.addUser.elements[i].type === "select") {
                        if (this.addUser.elements[i].label === "Authorization Group") {
                            this.addUser.elements[i].selectedValue = user.name;
                        } else {
                            this.addUser.elements[i].selectedValue = "Select";
                        }
                    } else {
                        this.addUser.elements[i].selectedValue = "";
                    }
                }
                this.addUser.okButton = "Add"
                this.addUser.state = true;
                break;
            case "edit":
                this.addUser.title = "Edit Configuration";
                this.addUser.subTitle = "Modify details";
                this.addUser.elements[0].selectedValue = user.name;
                this.addUser.elements[1].selectedValue = user.email;
                this.addUser.elements[2].selectedValue = user.type;
                this.addUser.elements[3].selectedValue = group;
                this.addUser.okButton = "Save"
                this.addUser.state = true;
                break;
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/authuser/authuser.component.ts